import { Auth } from 'aws-amplify';

var headers = null;

export function updateHeaders(session) {
    let idToken = session.getIdToken().getJwtToken();
    //let accessToken = session.getIdToken().getJwtToken();

    headers= {
        "Accept": "application/json",
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + idToken,
    };
}

export async function getHeaders() {
  if(headers)
    return headers;

  let session = await Auth.currentSession();

  if(!session)
  {
    headers = null;
    return null;
  }

  updateHeaders(session);

  return headers;
}
